import { CssBaseline } from "@mui/material";
import AppTheme from "../theme/AppTheme";
import AppAppBar from "./common/AppAppBar";
import Footer from "./common/Footer";
import { Outlet } from "react-router-dom";

export default function Layout(props: { disableCustomTheme?: boolean }) {
    return (
        <AppTheme {...props}>
            <CssBaseline enableColorScheme />
            <AppAppBar />
            <Outlet />
            <Footer />
        </AppTheme>
    );
}